import * as z from "zod";

export const AI_DISCLOSURE_VERSION = "2026-09-14";
export const AI_PRIVACY_URL = "https://hrok.bot/privacy/";
export const SUPERMEMORY_CLOUD_BASE_URL = "https://api.supermemory.ai";
export const AiDataUseSchema = z.enum(["model", "voice", "memory", "live"]);
export type AiDataUse = z.infer<typeof AiDataUseSchema>;
export const AiConnectionRecipientSchema = z.object({
  use: AiDataUseSchema,
  provider: z.string().min(1).max(200),
  baseUrl: z.string().min(1).max(2048).optional(),
  modelId: z.string().min(1).max(512).optional(),
});
export type AiConnectionRecipient = z.infer<typeof AiConnectionRecipientSchema>;
export const AiConnectionDataConsentSchema = z.object({
  scope: z.string().min(1).max(128),
  version: z.string().min(1).max(128),
  uses: z.array(AiDataUseSchema).min(1).max(4),
  recipients: z.array(AiConnectionRecipientSchema).min(1).max(4),
});
export type AiConnectionDataConsent = z.infer<typeof AiConnectionDataConsentSchema>;
export const AI_DATA_DISCLOSURES: Record<AiDataUse, string> = {
  model:
    "Messages, chat history, bot instructions, memories, attachments, screenshots and connected-app content are sent to run your bots, including routines.",
  voice:
    "Your recordings are sent for transcription, and text you play is sent to generate speech.",
  memory:
    "Conversation summaries, memories, searches and bot and Space IDs are sent to store and recall context.",
  live: "Your live audio, bot instructions and recent conversation context are sent to the selected service for a real-time voice conversation.",
};
export const AiConsentQuerySchema = z
  .object({
    botId: z.string().optional(),
    groupId: z.string().optional(),
    routineId: z.string().optional(),
    uses: z.array(AiDataUseSchema).optional(),
  })
  .default({});
export type AiConsentQuery = z.infer<typeof AiConsentQuerySchema>;
export const AiRecipientSchema = z.object({
  key: z.string(),
  name: z.string(),
  use: AiDataUseSchema,
  detail: z.string(),
  privacyUrl: z.string().url().optional(),
  allowed: z.boolean(),
});
export type AiRecipient = z.infer<typeof AiRecipientSchema>;
export const AiConsentStatusSchema = z.object({
  scope: z.string(),
  version: z.string(),
  recipients: z.array(AiRecipientSchema),
  privacyUrl: z.string().url().optional(),
});
export type AiConsentStatus = z.infer<typeof AiConsentStatusSchema>;
export const AI_CONSENT_REQUIRED = "Allow AI data sharing in settings before continuing.";
